module.exports = __webpack_public_path__ + "static/media/nav_cp_jzl_bg.b5661d51.png";